/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface AppApiRoutesSettingsMFAVerifyRequest {
  /**
     * @minLength 1
     * @maxLength 255
     */
  factor_id: string;
  /** @maxLength 255 */
  challenge_id: string;
  /**
     * @minLength 6
     * @maxLength 6
     * @pattern ^\d{6}$
     */
  code: string;
}
